/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityaspectfriendship2Inputs */



/**
* | output |
* | --- |
* | "Friendship" |
*
* @param {Personalityaspectfriendship2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityaspectfriendship2 = /** @type {((inputs?: Personalityaspectfriendship2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityaspectfriendship2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Friendship")
	if (locale === "es") return /** @type {LocalizedString} */ ("Amistad")
	return /** @type {LocalizedString} */ ("Дружба")
});
export { personalityaspectfriendship2 as "personalityAspectFriendship" }